<template>
  <div>
    <v-row class="v-col-12 pa-0 ma-0">
      <div
        v-if="!this.isBelowSmallestBreakpoint && !$rttI18n.$isWidget"
        :class="['v-row', 'v-col-12', $rttI18n.isGlsPlSelected && 'pb-0']"
      >
        <h1
          v-if="!$rttI18n.isGlsPlSelected"
          :class="['text-h3', 'pa-0', 'mr-4', 'my-4']"
          :style="{
            padding: '0 0 30px'
          }"
        >
          {{
            $t(
              $te('overview.headerDelivered')
                ? 'overview.headerDelivered'
                : 'overview.header'
            )
          }}
        </h1>
        <h1 v-else class="gls-pl-header font-weight-bold">
          {{
            $t(
              $te('overview.headerDelivered')
                ? 'overview.headerDelivered'
                : 'overview.header'
            )
          }}
        </h1>
      </div>
      <div
        v-if="this.isBelowSmallestBreakpoint && !$rttI18n.$isWidget"
        class="v-row my-0"
      >
        <v-col
          v-if="!$rttI18n.isGlsPlSelected"
          :style="{
            visibility: $rttI18n.isGlsItSelected ? 'hidden' : null
          }"
          class="d-flex text-right align-center font-weight-bold"
        >
          <h2>{{ $t('overview.title') }}</h2>
        </v-col>
        <v-col
          :class="[
            'd-flex',
            !$rttI18n.isGlsPlSelected && 'align-center justify-end',
            $rttI18n.isGlsPlSelected && 'flex-column'
          ]"
          :style="{
            'flex-basis': '50%',
            visibility: $rttI18n.isGlsUsSelected ? 'hidden' : null
          }"
        >
          <template v-if="$rttI18n.isGlsPlSelected">
            <h2 class="gls-pl-header font-weight-bold">
              {{
                $t(
                  $te('overview.headerDelivered')
                    ? 'overview.headerDelivered'
                    : 'overview.header'
                )
              }}
            </h2>
            <h2>
              {{ $rttI18n.tenantSpecificContent('trackingId') }}
              {{ this.trackingData.trackingId }}
            </h2>
          </template>
          <template v-else>
            <h2 class="font-weight-bold">{{ $t('generic.trackingId') }}</h2>
            : {{ this.trackingData.trackingId }}
          </template>
        </v-col>
      </div>
      <v-col
        :class="this.isBelowSmallestBreakpoint ? 'v-col-12' : 'v-col-6'"
        class="pa-0"
      >
        <MapContainer v-if="!this.isBelowSmallestBreakpoint" />
        <AdComponent
          v-if="
            !this.isBelowSmallestBreakpoint &&
            ((this.trackingData.ad && this.trackingData.ad.length) || 0) < 2
          "
          :adData="this.trackingData.ad"
        />
      </v-col>
      <v-col
        :class="isBelowSmallestBreakpoint ? 'v-col-12' : 'v-col-6 pl-4'"
        class="pa-0"
      >
        <OverviewComponent
          v-if="
            !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
          "
          @toggleDialog="dialogHandler"
        />
        <FeedbackComponent
          v-if="
            this.consigneeAddress &&
            !configGetter(this.$rttI18n.tenantId, this.themeId)
              .disableOverview &&
            !this.$rttI18n.isGlsPlSelected
          "
          :postcode="this.consigneeAddress.postcode"
          :ratingData="this.rating"
          :trackingId="this.trackingData.trackingId"
        />
        <MapContainer v-if="this.isBelowSmallestBreakpoint" />
        <FeedbackComponent
          v-if="
            this.consigneeAddress &&
            !configGetter(this.$rttI18n.tenantId, this.themeId)
              .disableOverview &&
            this.$rttI18n.isGlsPlSelected
          "
          :postcode="this.consigneeAddress.postcode"
          :ratingData="this.rating"
          :trackingId="this.trackingData.trackingId"
          class="feedback-component"
        />
        <AdComponent
          v-if="
            this.isBelowSmallestBreakpoint &&
            !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
          "
          :adData="this.trackingData.ad"
        />
        <DeliveryAddressComponent
          v-if="
            !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
          "
        />
      </v-col>
    </v-row>
    <AdComponent
      v-if="
        !this.isBelowSmallestBreakpoint &&
        (this.trackingData.ad && this.trackingData.ad.length) >= 2 &&
        !configGetter(this.$rttI18n.tenantId, themeId).disableOverview
      "
      :adData="this.trackingData.ad"
    />
  </div>
</template>

<script>
import AdComponent from '../AdComponent';
import DeliveryAddressComponent from '../DeliveryAddressComponent';
import FeedbackComponent from '../feedback/FeedbackComponent';
import MapContainer from '@/components/map/MapContainer';
import OverviewComponent from '../OverviewComponent';
import { configGetter } from '@/config/configGetter';
import { mapActions, mapState } from 'pinia';
import { useDialogStore } from '@/stores/dialog.js';
import { useResponsiveBreakpointsStore } from '@/stores/responsiveBreakpoints.js';
import { useThemeStore } from '@/stores/theme.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useRatingStore } from '@/stores/rating.js';

export default {
  name: 'RealTimeTrackingFinished',
  components: {
    AdComponent,
    DeliveryAddressComponent,
    FeedbackComponent,
    MapContainer,
    OverviewComponent
  },
  data() {
    return {
      configGetter
    };
  },
  computed: {
    ...mapState(useTrackingDataStore, {
      trackingData: 'data',
      consigneeAddress: 'consigneeAddress'
    }),
    ...mapState(useThemeStore, ['themeId']),
    ...mapState(useResponsiveBreakpointsStore, ['isBelowSmallestBreakpoint']),
    ...mapState(useRatingStore, ['rating'])
  },
  methods: {
    ...mapActions(useDialogStore, ['toggleDialog']),
    dialogHandler(dialog) {
      this.toggleDialog(dialog);
    }
  }
};
</script>

<style scoped>
.feedback-component {
  margin-top: 1.5em;
  margin-bottom: 1em !important;
}
.gls-pl-header {
  font-size: 1.1em;
}
</style>
